import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Servicio para manejo de peticion de token 
 */
@Injectable()
export class TokenService {
  /**
   * Subscripcion como observable
   */
  private subject = new Subject<any>();

  /**
   * Presenta mensaje en pantalla
   * @param message 
   */
  sendMessage(message: string){
    this.subject.next({response:message});
  }
  /**
   * Oculta el mensaje
   */
  clearMessage() {
    this.subject.next(null);
  }

  /**
   * Obtiene el resultado de la interaccion
   */
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
